export default function ActionButton({
  buttonText,
  buttonValue,
  buttonAction,
}) {
  return (
    <button
      className="btn fw-bold bg-main-purple w-100"
      value={buttonValue}
      onClick={buttonAction}
      style={{
        borderRadius: "12px",
        padding: "0.75rem 1rem",
        fontSize: "1rem",
        letterSpacing: "0.02em",
      }}
    >
      {buttonText}
    </button>
  );
}
